var map = {
	"./en/common.json": 13514,
	"./en/menu.json": 93295,
	"./en/pages/faqs.json": 39273,
	"./en/pages/help.json": 87569,
	"./en/pages/login.json": 87891,
	"./en/pages/mark_proof.json": 2080,
	"./en/pages/notfound.json": 40836,
	"./en/pages/privacy_policy.json": 67732,
	"./en/pages/profile.json": 73793,
	"./en/pages/search.json": 5532,
	"./en/pages/terms_conditions.json": 46214,
	"./en/pages/token.json": 95158,
	"./en/pages/token_list.json": 59143,
	"./en/pages/transactions.json": 18131,
	"./en/pages/verification.json": 15299,
	"./en/pages/wallet.json": 52447,
	"./fr/common.json": 4299,
	"./fr/menu.json": 60373,
	"./fr/pages/faqs.json": 77439,
	"./fr/pages/help.json": 79935,
	"./fr/pages/login.json": 67394,
	"./fr/pages/mark_proof.json": 51572,
	"./fr/pages/notfound.json": 67283,
	"./fr/pages/privacy_policy.json": 40106,
	"./fr/pages/profile.json": 41869,
	"./fr/pages/terms_conditions.json": 28984,
	"./fr/pages/token.json": 38818,
	"./fr/pages/token_list.json": 22208,
	"./fr/pages/transactions.json": 14784,
	"./fr/pages/verification.json": 97525,
	"./fr/pages/wallet.json": 29571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98143;